(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ware-gift-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initQuiz(root) {
      if (!root || root.dataset.wqReady) return;
      root.dataset.wqReady = '1';

      var sid = root.dataset.sectionId;
      var storeKey = 'wareQuiz:' + sid;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var inEditor = !!(window.Shopify && window.Shopify.designMode);

      var products = [];
      try { products = JSON.parse(root.querySelector('[data-wq-products]').textContent) || []; } catch (e) { products = []; }

      var steps = [].slice.call(root.querySelectorAll('.wq-step'));
      var qSteps = steps.filter(function (s) { return s.dataset.step === 'q'; });
      var total = qSteps.length;
      var resultsIndex = total + 1;

      var top = root.querySelector('.wq-top');
      var bar = root.querySelector('.wq-bar');
      var nextBtn = root.querySelector('[data-wq-next]');
      var skipBtn = root.querySelector('[data-wq-skip]');
      var countEl = root.querySelector('[data-wq-count]');
      var fill = root.querySelector('.wq-fill');
      var statusEl = root.querySelector('[data-wq-status]');

      var state = { answers: {}, message: '' };
      var current = 0;
      var timer = null;

      function optsOf(step) { return [].slice.call(step.querySelectorAll('.wq-opt')); }
      function layoutOf(step) { return step.dataset.layout; }
      function selected(i) { return state.answers[i] || []; }
      function answered(i) { var s = qSteps[i]; return !!s && (layoutOf(s) === 'text' || selected(i).length > 0); }
      function picksOf(i) {
        var s = qSteps[i]; if (!s) return [];
        var o = optsOf(s);
        return selected(i).map(function (k) { return o[k] && o[k].dataset.label; }).filter(Boolean);
      }

      function save() {
        if (inEditor) return;
        try { sessionStorage.setItem(storeKey, JSON.stringify({ answers: state.answers, message: state.message, step: current })); } catch (e) {}
      }
      function load() {
        try {
          var d = JSON.parse(sessionStorage.getItem(storeKey) || 'null');
          if (d) { state.answers = d.answers || {}; state.message = d.message || ''; return d; }
        } catch (e) {}
        return null;
      }

      function paint(i) {
        var s = qSteps[i]; if (!s) return;
        var sel = selected(i);
        optsOf(s).forEach(function (b, k) { b.setAttribute('aria-pressed', sel.indexOf(k) > -1 ? 'true' : 'false'); });
        var ta = s.querySelector('[data-wq-message]');
        if (ta && ta.value !== state.message) ta.value = state.message;
      }

      function updateBar() {
        var i = current - 1, s = qSteps[i];
        if (!s) return;
        nextBtn.disabled = !answered(i);
        nextBtn.textContent = i === total - 1 ? root.dataset.finishLabel : root.dataset.nextLabel;
        skipBtn.hidden = layoutOf(s) !== 'text';
      }

      function show(n, opts) {
        opts = opts || {};
        n = Math.max(0, Math.min(n, resultsIndex));
        clearTimeout(timer);
        steps.forEach(function (s, k) { s.classList.toggle('is-active', k === n); });
        current = n;

        var inQuestion = n >= 1 && n <= total;
        top.hidden = n === 0 || n === resultsIndex;
        bar.hidden = !inQuestion;
        if (n >= 1) {
          var plabel = root.dataset.progressLabel || 'Round [n] of [total]';
          countEl.textContent = n > total ? 'Your hand' : plabel.replace('[n]', n).replace('[total]', total);
          fill.style.width = (n > total ? 100 : Math.round((n / total) * 100)) + '%';
        }
        if (inQuestion) { paint(n - 1); updateBar(); }
        if (n === resultsIndex) renderResults();

        if (opts.push !== false) { try { history.pushState({ wq: sid, step: n }, ''); } catch (e) {} }
        save();

        if (opts.focus !== false) {
          var rect = root.getBoundingClientRect();
          if (rect.top < 0) window.scrollTo({ top: rect.top + window.pageYOffset - 8, behavior: reduce ? 'auto' : 'smooth' });
          var h = steps[n] && steps[n].querySelector('[data-wq-focus]');
          if (h) { try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
        }
      }

      /* ---------- Recommendations ---------- */
      function chosen() {
        var tags = [], labels = [], budget = null;
        qSteps.forEach(function (s, i) {
          var o = optsOf(s);
          selected(i).forEach(function (k) {
            var b = o[k]; if (!b) return;
            labels.push(b.dataset.label);
            if (layoutOf(s) === 'budget') {
              var mn = parseFloat(b.dataset.min) || 0, mx = parseFloat(b.dataset.max) || 0;
              if (mn || mx) budget = { min: mn * 100, max: mx ? mx * 100 : Infinity };
            }
            (b.dataset.tags || '').split(',').forEach(function (t) { t = t.trim().toLowerCase(); if (t) tags.push(t); });
          });
        });
        return { tags: tags, labels: labels, budget: budget };
      }

      function rank() {
        var c = chosen(), wanted = {}, b = c.budget;
        c.tags.forEach(function (t) { wanted[t] = true; });
        return products.map(function (p, idx) {
          var score = 0;
          (p.tags || []).forEach(function (t) { if (wanted[String(t).toLowerCase()]) score += 2; });
          var lo = p.price, hi = p.price_max || p.price, inRange = true;
          // In range if any variant price falls in [min, max): ₹2,000 goes to 2,000–5,000, not "Under 2,000"
          if (b) inRange = hi >= b.min && lo < b.max;
          return { p: p, score: score, inRange: inRange, idx: idx };
        })
        // Only products in the budget that match at least one of the shopper's picks
        .filter(function (r) { return r.inRange && r.score > 0; })
        .sort(function (a, b) {
          return (b.p.available - a.p.available) ||
                 (b.score - a.score) ||
                 (a.idx - b.idx);
        });
      }

      function esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
        });
      }
            function joinNice(list) {
        if (list.length < 2) return list.join('');
        return list.slice(0, -1).join(', ') + ' and ' + list[list.length - 1];
      }

      // Builds the results sentence from the template; returns '' if any answer lacks a phrase
      function story() {
        var tpl = root.dataset.story || '';
        if (!tpl) return '';
        var ok = true;
        var out = esc(tpl).replace(/\{(\d+)\}/g, function (_, d) {
          var i = parseInt(d, 10) - 1, s = qSteps[i];
          if (!s) { ok = false; return ''; }
          var o = optsOf(s);
          var ph = selected(i).map(function (k) { return o[k] && o[k].dataset.phrase; });
          if (!ph.length || ph.some(function (p) { return !p; })) { ok = false; return ''; }
          return '<em>' + esc(joinNice(ph)) + '</em>';
        });
        return ok ? out : '';
      }

      // Photos from the image cards the shopper picked

      function card(r) {
        var p = r.p;
        var media = p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.alt) + '" loading="lazy" width="600" height="600">' : '';
        var price = (p.compare > p.price ? '<s>' + esc(p.compare_fmt) + '</s>' : '') + esc(p.price_fmt);
        var action;
        if (!p.available) action = '<button type="button" class="wq-card__btn" disabled>Sold out</button>';
        else if (p.single) action = '<button type="button" class="wq-card__btn" data-wq-add="' + p.variant + '">Add to cart</button>';
        else action = '<a class="wq-card__btn" href="' + esc(p.url) + '">Choose options</a>';
        return '<li class="wq-card">' +
          '<a class="wq-card__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + media + '</a>' +
          '<a class="wq-card__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<div class="wq-card__price">' + price + '</div>' + action + '</li>';
      }

      function summary() {
        return qSteps.map(function (s, i) {
          var picks = picksOf(i);
          if (layoutOf(s) === 'text' && state.message) picks.push('"' + state.message + '"');
          return s.dataset.question + ': ' + (picks.join(', ') || '-');
        }).join('\n');
      }

      function syncLead() {
        var wa = root.querySelector('[data-wq-wa]');
        if (wa) wa.href = 'https://wa.me/' + wa.dataset.number + '?text=' + encodeURIComponent(root.dataset.waText + '\n\n' + summary());
        // Fill the Zoho hidden fields with the shopper's answers
        root.querySelectorAll('[data-wq-answer]').forEach(function (el) {
          el.value = picksOf(parseInt(el.dataset.wqAnswer, 10)).join(', ');
        });
      }

      function renderResults() {
        var c = chosen();
        var storyEl = root.querySelector('[data-wq-story]');
        var chipsEl = root.querySelector('[data-wq-chips]');

        var text = story();
        if (text) {
          storyEl.innerHTML = text;
          storyEl.hidden = false;
          chipsEl.hidden = true;
        } else {
          storyEl.textContent = storyEl.dataset.fallback || '';
          storyEl.hidden = !storyEl.dataset.fallback;
          chipsEl.innerHTML = c.labels.map(function (l) { return '<li class="wq-chip">' + esc(l) + '</li>'; }).join('');
          chipsEl.hidden = !c.labels.length;
        }

        var grid = root.querySelector('[data-wq-grid]');
        var list = rank().slice(0, parseInt(root.dataset.limit, 10) || 6);
        grid.innerHTML = list.length ? list.map(card).join('') : '<li class="wq-empty">' + esc(root.dataset.emptyText) + '</li>';

        // Top pick's photo beside the heading
        var ace = root.querySelector('[data-wq-ace]');
        var top = list[0] && list[0].p;
        if (ace) {
          ace.innerHTML = top && top.image ? '<img src="' + esc(top.image) + '" alt="" width="600" height="600">' : '';
          ace.hidden = !ace.innerHTML;
        }
        if (statusEl) statusEl.textContent = '';
        syncLead();
      }

      /* ---------- Cart ---------- */
      function refreshCartCount(base) {
        fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count], .cart-count-bubble span[aria-hidden="true"]').forEach(function (el) { el.textContent = cart.item_count; });
          }).catch(function () {});
      }

      function addToCart(btn) {
        if (btn.dataset.busy) return;
        btn.dataset.busy = '1';
        var label = btn.textContent;
        var id = parseInt(btn.dataset.wqAdd, 10);
        var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        btn.textContent = 'Adding…';
        fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add this item.'); });
            return r.json();
          })
          .then(function () {
            btn.textContent = 'Added';
            btn.classList.add('is-added');
            if (!btn.nextElementSibling || !btn.nextElementSibling.classList.contains('wq-card__cart')) {
              btn.insertAdjacentHTML('afterend', '<a class="wq-card__cart" href="' + base + 'cart">View cart</a>');
            }
            if (statusEl) statusEl.textContent = 'Added to your cart.';
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('ware-quiz:added', { detail: { variantId: id } }));
            try {
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ware-quiz', productVariantId: id });
              }
            } catch (e) {}
            refreshCartCount(base);
          })
          .catch(function (err) {
            btn.textContent = label;
            if (statusEl) statusEl.textContent = err.message;
          })
          .then(function () { delete btn.dataset.busy; });
      }

      /* ---------- Events ---------- */
      root.addEventListener('click', function (e) {
        var opt = e.target.closest('.wq-opt');
        if (opt && root.contains(opt)) {
          var s = opt.closest('.wq-step'), i = qSteps.indexOf(s);
          if (i < 0) return;
          var k = optsOf(s).indexOf(opt), L = layoutOf(s), sel = selected(i).slice();
          if (L === 'multi') { var at = sel.indexOf(k); if (at > -1) sel.splice(at, 1); else sel.push(k); }
          else if (L === 'text') { sel = sel[0] === k ? [] : [k]; }
          else { sel = [k]; }
          state.answers[i] = sel;
          paint(i); updateBar(); save();
          if ((L === 'image' || L === 'single' || L === 'budget') && !inEditor) {
            clearTimeout(timer);
            timer = setTimeout(function () { if (current === i + 1) show(current + 1); }, reduce ? 120 : 320);
          }
          return;
        }
        if (e.target.closest('[data-wq-start]')) { show(1); return; }
        if (e.target.closest('[data-wq-next]')) { if (answered(current - 1)) show(current + 1); return; }
        if (e.target.closest('[data-wq-skip]')) { state.answers[current - 1] = []; state.message = ''; show(current + 1); return; }
        if (e.target.closest('[data-wq-back]')) { show(current - 1); return; }
        if (e.target.closest('[data-wq-edit]')) { show(1); return; }
        if (e.target.closest('[data-wq-restart]')) { state = { answers: {}, message: '' }; qSteps.forEach(function (_, i) { paint(i); }); show(1); return; }
        var add = e.target.closest('[data-wq-add]');
        if (add) addToCart(add);
      });

      root.addEventListener('input', function (e) {
        if (e.target.matches('[data-wq-message]')) { state.message = e.target.value; save(); }
      });

      /* Catalog form → Zoho: split the name, clean the number, come back here afterwards */
      var leadForm = root.querySelector('.wq-lead__form');
      if (leadForm) leadForm.addEventListener('submit', function () {
        var parts = (root.querySelector('[data-wq-fullname]').value || '').trim().split(/\s+/);
        root.querySelector('[data-wq-first]').value = parts.shift() || '';
        root.querySelector('[data-wq-last]').value = parts.join(' ') || '-';
        var ph = root.querySelector('[data-wq-phone]');
        ph.value = ph.value.replace(/\D/g, '');
        // No number typed: don't send the country code on its own
        var code = root.querySelector('[data-wq-code]');
        if (code) code.disabled = !ph.value;
        var u = new URL(window.location.href);
        u.searchParams.set('wq_sent', '1');
        u.hash = '';
        root.querySelector('[data-wq-redirect]').value = u.toString();
        syncLead(); save();
      });

      window.addEventListener('popstate', function (e) {
        var st = e.state;
        if (st && st.wq === sid) show(st.step, { push: false });
        else if (current !== 0) show(0, { push: false });
      });

      root._wqGoToElement = function (el) {
        var k = steps.indexOf(el.closest('.wq-step'));
        if (k > -1) show(k, { push: false, focus: false });
      };

      /* ---------- Start ---------- */
      var saved = inEditor ? null : load();
      var sent = /[?&]wq_sent=1/.test(window.location.search);
      var start = 0;
      if (sent) start = resultsIndex;
      else if (saved && saved.step > 0 && saved.step <= resultsIndex) start = saved.step;

      var cleanUrl = sent ? window.location.href.replace(/([?&])wq_sent=1&?/, '$1').replace(/[?&]$/, '') : undefined;
      try { history.replaceState({ wq: sid, step: start }, '', cleanUrl); } catch (e) {}
      show(start, { push: false, focus: false });

      if (sent) {
        var thanks = root.querySelector('[data-wq-thanks]');
        var lf = root.querySelector('.wq-lead__form');
        if (thanks) thanks.hidden = false;
        if (lf) lf.hidden = true;
        var lead = root.querySelector('.wq-lead');
        if (lead) lead.scrollIntoView({ block: 'center' });
      }
    }

    function initAll() { document.querySelectorAll('.ware-quiz').forEach(initQuiz); }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();

    document.addEventListener('shopify:section:load', function (e) { initQuiz(e.target.querySelector('.ware-quiz')); });
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest('.ware-quiz');
      if (root && root._wqGoToElement) root._wqGoToElement(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ware-quiz-card"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'wareQuizFloat:hidden';

    // Bottom edge of the header, or 0 if it has scrolled away.
    // Only counts bars stacked from the very top of the screen (announcement bar + header),
    // so section titles further down the page can never be mistaken for the header.
    function headerBottom() {
      var els = document.querySelectorAll('.shopify-section-group-header-group, sticky-header, .header-wrapper, .header-sticky-wrapper, .site-header, #StickyHeaderWrap');
      var rects = [];
      for (var i = 0; i < els.length; i++) {
        var r = els[i].getBoundingClientRect();
        if (r.height && r.height < 260 && r.bottom > 0 && getComputedStyle(els[i]).visibility !== 'hidden') rects.push(r);
      }
      rects.sort(function (a, b) { return a.top - b.top; });
      var b = 0;
      for (var j = 0; j < rects.length; j++) {
        if (rects[j].top > b + 4) break;
        if (rects[j].bottom > b) b = rects[j].bottom;
      }
      return Math.max(Math.round(b), 0);
    }

    function init() {
      var el = document.querySelector('[data-wq-float]');
      if (!el || el.dataset.ready) return;
      el.dataset.ready = '1';

      var force = /[?&]wqf=1/.test(window.location.search);
      var link = el.querySelector('a');
      var here = window.location.pathname.replace(/\/$/, '');
      var onQuizPage = !!document.querySelector('.ware-quiz') || (link && link.pathname.replace(/\/$/, '') === here && here !== '');
      var dismissed = false;
      try { dismissed = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
      if (force) {
        try { sessionStorage.removeItem(KEY); } catch (e) {}
      } else if (onQuizPage || dismissed) return;

      // Move to <body> so animated or overflow-hidden theme wrappers can't trap it
      document.body.appendChild(el);
      el.hidden = false;

      var ticking = false;
      var lastH = -1;
      var settle = null;

      function update() {
        ticking = false;
        // Only move when the header really moved, so small re-measures don't nudge the card
        var h = headerBottom();
        if (Math.abs(h - lastH) > 2) {
          lastH = h;
          el.style.setProperty('--wqf-header', h + 'px');
        }
        // Hide while a header dropdown or mega menu is open
        el.classList.toggle('is-hidden', !!document.querySelector('header details[open], .header details[open]'));
      }
      function queue() {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }
      // While scrolling, and once more after it stops (when the sticky header has finished sliding)
      function onScroll() {
        queue();
        clearTimeout(settle);
        settle = setTimeout(queue, 450);
      }

      update();
      // Turn on the smooth glide only after the first position is set
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { el.classList.add('is-ready'); });
      });

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      window.addEventListener('load', queue);
      document.addEventListener('toggle', queue, true);
      document.addEventListener('click', function () { setTimeout(queue, 50); }, true);

      var close = el.querySelector('[data-wq-float-close]');
      if (close) close.addEventListener('click', function (e) {
        e.preventDefault();
        el.hidden = true;
        try { sessionStorage.setItem(KEY, '1'); } catch (e2) {}
      });

      // Hide while typing, so it never floats over the iPhone keyboard
      document.addEventListener('focusin', function (e) {
        if (e.target.matches && e.target.matches('input, textarea, select')) el.classList.add('is-typing');
      });
      document.addEventListener('focusout', function () {
        el.classList.remove('is-typing');
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();

    document.addEventListener('shopify:section:load', function () {
      var old = document.body.querySelectorAll(':scope > [data-wq-float]');
      for (var i = 0; i < old.length - 1; i++) old[i].remove();
      init();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
